<template>
    <transition name="modal">
        <div class="modal__mask modalRepresentantesFatca" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal">
                        <a
                            @click.stop.prevent="closeModal"
                            class="close__modal"
                        >
                            x
                        </a>
                        <div class="inner__modal">
                            <div style="width: 100%">
                                <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                                    <img style="width: 50px; height: 50px; margin-top: 0px;" src="@/assets/addRepresentante.png" />
                                </div>
                                 <div style="width: 100%; display: flex; flex-direction: column; align-items: center;">
                                <h2 style="
                                margin-top: 0px; margin-bottom: 40px;
                                font-size: 16px;">Adicionar pessoa politicamente exposta</h2>
                                 </div>
                            </div>

                            <form
                                action=""
                                class="form__class"
                                @submit.stop.prevent="createRepresentante"
                            >

                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            Nome
                                        </label>

                                        <input
                                            type="text"
                                            class="field fieldSemEspacamento"
                                            autocomplete="off"
                                            v-model="representante.Nome"     
                                            
                                            @click.stop.prevent="clear"
                                            :class="{ erro: erroName }"
                                        />
                                        <p v-if="erroName" class="erro">
                                            Campo obrigatório.
                                        </p>
                                    </div>
                                </div>

                                                            


                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            CPF
                                        </label>

                                        <input
                                            type="text"
                                            class="field fieldSemEspacamento"
                                            autocomplete="off"
                                            @click.stop.prevent="clear"  
                                            v-model="representante.Cpf"                                  
                                        />                                        
                                    </div>
                                </div>



                                 <div class="row">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            Grau de relacionamento
                                        </label>

                                        <input
                                            type="text"
                                            class="field fieldSemEspacamento"
                                            autocomplete="off"
                                            @click.stop.prevent="clear"  
                                            v-model="representante.GrauRelacionamento"                                         
                                        />                                        
                                    </div>
                                </div>

                                
                                 <div class="row">
                                    <div class="form__controls">
                                        <label class="label__field">
                                            Cargo/Órgão
                                        </label>

                                        <input
                                            type="text"
                                            class="field fieldSemEspacamento"
                                            autocomplete="off"
                                            @click.stop.prevent="clear"  
                                            v-model="representante.Cargo"                                         
                                        />                                        
                                    </div>
                                </div>



                                <div class="buttonsAcoes" style="margin-top: 40px;">         
                                                                        <button                                    
                                            class="btnDefault"
                                            type="button"
                                            @click="closeModal"
                                        >
                                            Cancelar
                                        </button>                                 
                                    <button            
                                            v-if="representante.Guid == ''"                        
                                            class="btnBlue"
                                            type="button"
                                            @click="salvarRepresentante"
                                        >
                                            Adicionar
                                        </button>          

                                                                            <button     
                                            v-if="representante.Guid != ''"                                      
                                            class="btnBlue"
                                            type="button"
                                            @click="salvarRepresentante"
                                        >
                                            Atualizar
                                        </button>      

                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';
import { VMoney } from 'v-money'

export default {
    directives: {
      money: VMoney
    },
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_PJ_ADD_PESSOA_PEP",
            editarRepresentante: 'GET_MODAL_PJ_EDITAR_PESSOA_PEP',
            user: 'auth/user',
        }),
    },
    data() {
    return {
        disableBtn: false,
        erroName: '',
        representante: {
            Guid: '',
            ClienteId: '',
            Nome: '',
            Cpf: '',
            Cargo: '',
            GrauRelacionamento: '',
            },
         opcoesDeMoeda: {
          decimal: ',',
          thousands: '.',
          suffix: ' %',
          precision: 2
        },
        }
    },
    mounted() {
        this.representante.ClienteId = this.user.ClienteId;
    },
    watch: {
        editarRepresentante(){
            if(this.editarRepresentante == null){
                this.limparObj();
            }else{
            this.representante = this.editarRepresentante;
            }
        }
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_PJ_ADD_PESSOA_PEP", false);
            this.$store.commit("SET_MODAL_PJ_EDITAR_PESSOA_PEP", null);
            
        },
        limparObj(){
            this.representante = {
                Guid: '', // valor padrão
                ClienteId: this.user.ClienteId, // valor padrão
                Nome: '', // valor padrão
                Cargo: '',
                Cpf: '', // valor padrão
                GrauRelacionamento: '',
            };
        },
        async salvarRepresentante(){
             this.disableBtn = true;
              

                await api
                    .post('/fundo/pep', this.representante)
                    .then((retorno) => {
                          this.disableBtn = false;
                        if(retorno.status == 200)
                        {

                          this.$swal({
                              icon: 'success',
                              title: this.representante.Guid == '' ? 'Inclusão realizada com sucesso!' : 'Alteração realizada com sucesso!',
                              text: 'Dados informados foram salvos com sucesso.',
                          });
                           this.limparObj();

                           this.$store.commit("SET_MODAL_PJ_ADD_PESSOA_PEP", false);
                           this.$store.commit("SET_MODAL_PJ_EDITAR_PESSOA_PEP", null);

                           this.$store.dispatch('FETCH_FI_LISTA_PEP', this.user.ClienteId);

                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        this.disableBtn = false;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos informado para representante',
                            text: '',
                        });
                    });

        }
    },
};
</script>

<style lang="scss" scoped>
    .row{
       margin-left: 15px  !important;
    }

    .form__controls{
        width: 70% !important;
    }

    .buttonsAcoes{
        display: flex !important;
        flex-direction: row;
        align-items: center !important;
    }
</style>

<style lang="scss">
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

  .modal__mask {
      .fieldSemEspacamento {
             padding: 10px 0px 10px 5px !important; 

      }


  }

.subTitle{
    color: #383333;;
    margin-top: -30px;
    margin-bottom: 30px; 
    font-size: large; 
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.modalRepresentantesFatca .modal__wrapper .modal__container.reset {
        width: 450px !important;
        height: 636px !important;
}

.titleConta{
        font-weight: 800 !important;
        text-transform: uppercase;
}

.btnLogin{
    background-color: #565656 !important;
}

.subTitleCinza{
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
        font-family: "Work Sans", sans-serif;
}

.content__modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>
